import { createSlice } from "@reduxjs/toolkit";

export const apiSettingSlice = createSlice({
  name: "apiSetting",
  initialState: {
    getApiSettingResult: false,
    getApiSettingLoading: false,
    getApiSettingError: false,
    addApiSettingResult: false,
    addApiSettingLoading: false,
    deleteApiSettingResult: false,
  },
  reducers: {
    apiSettingReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_APISETTING":
          return {
            ...state,
            getApiSettingResult: payload.data,
            getApiSettingLoading: payload.loading,
            getApiSettingError: payload.error,
          };
        case "ADD_APISETTING":
          return {
            ...state,
            addApiSettingResult: payload.data,
            addApiSettingLoading: payload.loading,
          };
        case "DELETE_APISETTING":
          return {
            ...state,
            deleteApiSettingResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { apiSettingReducers } = apiSettingSlice.actions;

export default apiSettingSlice.reducer;
